import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';

const OperationIndex = () => {
    const navigate = useNavigate();

    // Configuração de filtros específica para SubSectionKPI
    const filterConfig = useMemo(() => [        
        {
            type: "text",
            name: "description",
            label: "Description",
            placeholder: "Description..."
        }        
    ], []);

    // Colunas da tabela
    const columns = useMemo(() => [        
        { 
            title: 'Form Description', 
            dataIndex: 'description', 
            key: 'description', 
            sortable: true 
        },
        { 
            title: 'Guidance', 
            dataIndex: 'guidance', 
            key: 'guidance', 
            sortable: false 
        },
        { 
            title: 'Order', 
            dataIndex: 'order', 
            key: 'order', 
            sortable: true 
        },        
        { 
            title: 'Active', 
            dataIndex: 'isActive', 
            key: 'isActive', 
            width: 80,
            render: (value, record, index, handleToggleActive) => (
                <span 
                    className={`badge ${value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleActive && handleToggleActive(record)}
                    title={`Click to ${value ? 'deactivate' : 'activate'}`}
                >
                    {value ? 'Active' : 'Inactive'}
                </span>
            )
        },
        { 
            title: 'Deleted', 
            dataIndex: 'isDeleted', 
            key: 'isDeleted', 
            width: 100,
            render: (value, record, index, handleToggleActive, handleToggleDeleted) => (
                <span 
                    className={`badge ${!value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleDeleted && handleToggleDeleted(record)}
                    title={`Click to ${!value ? 'delete' : 'restore'}`}
                >
                    {!value ? 'Not Deleted' : 'Deleted'}
                </span>
            )
        }
    ], []);

    // Actions
    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/operation/edit/${record.operationID}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="Operation"
            apiEndpoint="/operation/getAllPaginated"
            toggleActiveEndpoint="/operation/toggleActive"
            toggleDeletedEndpoint="/operation/toggleDeleted"
            newRoute="/operation/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="operationID"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default OperationIndex;
